import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Input, Button, Label } from "reactstrap";
import swal from "sweetalert";
import { _PostSave, _GetByUrl, deleteUnits, SaveUnit } from "../../ApiEndPoint/ApiCalling";
import { saveUnit, viewUnits } from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
export default function Unit() {
  const [units, setUnits] = useState([]);
  const [unitInnerId, setUnitInnerId] = useState("");

  const [selectedUnit, setSelectedUnit] = useState({
    unitId: "",
    unitName: "",
  });

  const [customUnit, setCustomUnit] = useState("");

  // 🔹 Predefined Units
   const dummyUnits = [
    { unitValue: 'Bag', unitName: 'BAGS(Bag)' },
    { unitValue: 'Btl', unitName: 'BOTTLES(Btl)' },
    { unitValue: 'Box', unitName: 'BOX(Box)' },
    { unitValue: 'Bdl', unitName: 'BUNDLES(Bdl)' },
    { unitValue: 'Can', unitName: 'CANS(Can)' },
    { unitValue: 'Ctn', unitName: 'CARTONS(Ctn)' },
    { unitValue: 'Dzn', unitName: 'DOZENS(Dzn)' },
    { unitValue: 'Gm', unitName: 'GRAMMES(Gm)' },
    { unitValue: 'Kg', unitName: 'KILOGRAMS(Kg)' },
    { unitValue: 'Ltr', unitName: 'LITRE(Ltr)' },
    { unitValue: 'Mtr', unitName: 'METERS(Mtr)' },
    { unitValue: 'Ml', unitName: 'MILILITRE(Ml)' },
    { unitValue: 'Nos', unitName: 'NUMBERS(Nos)' },
    { unitValue: 'Pac', unitName: 'PACKS(Pac)' },
    { unitValue: 'Prs', unitName: 'PAIRS(Prs)' },
    { unitValue: 'Pcs', unitName: 'PIECES(Pcs)' },
    { unitValue: 'Qtl', unitName: 'QUINTAL(Qtl)' },
    { unitValue: 'Rol', unitName: 'ROLLS(Rol)' },
    { unitValue: 'Sqf', unitName: 'SQUARE FEET(Sqf)' },
    { unitValue: 'kg', unitName: 'Kilogram(kg)' },
    { unitValue: 'Pcs', unitName: 'Pieces(Pcs)' },
    { unitValue: 'g', unitName: 'Gram(g)' },
    { unitValue: 'tonne', unitName: 'Metric Ton(tonne)' },
    { unitValue: 'm', unitName: 'Meter(m)' },
    { unitValue: 'cm', unitName: 'Centimeter(cm)' },
    { unitValue: 'mm', unitName: 'Millimeter(mm)' },
    { unitValue: 'in', unitName: 'Inch(in)' },
    { unitValue: 'ft', unitName: 'Foot(ft)' },
    { unitValue: 'm3', unitName: 'Cubic Meter(m³)' },
    { unitValue: 'L', unitName: 'Liter(L)' },
    { unitValue: 'ml', unitName: 'Milliliter(ml)' },
    { unitValue: 's', unitName: 'Second(s)' },
    { unitValue: 'min', unitName: 'Minute(min)' },
    { unitValue: 'hr', unitName: 'Hour(hr)' },
    { unitValue: '°C', unitName: 'Celsius(°C)' },
    { unitValue: '°F', unitName: 'Fahrenheit(°F)' },
    { unitValue: 'Pa', unitName: 'Pascal(Pa)' },
    { unitValue: 'bar', unitName: 'Bar(bar)' },
    { unitValue: 'm/s', unitName: 'Meters per Second(m/s)' },
    { unitValue: 'km/h', unitName: 'Kilometers per Hour(km/h)' },
    { unitValue: 'A', unitName: 'Ampere(A)' },
    { unitValue: 'V', unitName: 'Volt(V)' },
    { unitValue: 'W', unitName: 'Watt(W)' },
    { unitValue: 'kW', unitName: 'Kilowatt(kW)' },
  ];

  // 📦 Fetch Units
const fetchUnits = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  try {
    const res = await axiosConfig.get(
      `/units/view-unit/${userData.database}`
    );

    const dynamicUnits = res?.data?.dynamicUnit || [];

    // ✅ parent _id attach karo
    const allUnits = dynamicUnits.flatMap((item) =>
      (item.Units || []).map((u) => ({
        ...u,
        parentId: item._id,
      }))
    );

    setUnits(allUnits);

  } catch (err) {
    console.log("Fetch Error:", err?.response || err.message);
  }
};

  useEffect(() => {
    fetchUnits();
  }, []);



 const handleSubmit = async (e) => {
  e.preventDefault();

  let finalUnit = {};

  if (customUnit.trim()) {
    // ✅ custom case
    finalUnit = {
      unitId: customUnit.trim(),     // short id
      unitName: customUnit.trim(),   // same label
    };
  } else {
    if (!selectedUnit.unitId || !selectedUnit.unitName) {
      swal("Please select or enter unit");
      return;
    }

    // ✅ dropdown case (IMPORTANT)
    finalUnit = {
      unitId: selectedUnit.unitId,   // ex: Box
      unitName: selectedUnit.unitName, // ex: BOX(Box)
    };
  }

  const userData = JSON.parse(localStorage.getItem("userData"));

  const payload = {
    created_by: userData?._id,
    database: userData?.database,
    Units: [finalUnit],
  };
  console.log("FINAL PAYLOAD =>", payload);
  try {
    const res = await axiosConfig.post("/units/save-unit", payload);

    if (res?.status === 200 || res?.data?.status) {
      swal("Success", "Unit Added", "success");
setUnits((prev) => [
  ...prev,
  finalUnit,
]);
      fetchUnits();

      // reset
      setSelectedUnit({ unitId: "", unitName: "" });
      setCustomUnit("");
    }
  } catch (error) {
    console.error("API error:", error);
    swal("Error", "Something went wrong", "error");
  }
};
  // ❌ Delete
const handleDelete = async (parentId, unitId) => {
  try {
    const res = await deleteUnits(parentId, unitId);

    if (res?.status || res?.data?.status) {
      swal("Deleted", "Unit deleted", "success");

      fetchUnits();
    }
  } catch (err) {
    console.log(err);
    swal("Error deleting");
  }
};

  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
          <h3>Unit Management</h3>

          {/* ✅ Form */}
          <form onSubmit={handleSubmit}>
            <Row>
              {/* Select Unit */}
              <Col md="4">
                <Label>Select Unit</Label>
                <Input
                  type="select"
                  value={selectedUnit.unitId}
                  onChange={(e) =>
  setSelectedUnit({
    unitId: e.target.value,
    unitName: e.target.options[e.target.selectedIndex].text,
  })
}
                  disabled={!!customUnit}
                >
                  <option value="">Select Unit</option>
                  {dummyUnits.map((u, i) => (
                    <option key={i} value={u.unitValue}>
                      {u.unitName}
                    </option>
                  ))}
                </Input>
              </Col>

              {/* Custom Unit */}
              <Col md="4">
                <Label>Or Enter Custom Unit</Label>
                <Input
                  type="text"
                  value={customUnit}
                  placeholder="Enter unit"
                  onChange={(e) => {
                    setCustomUnit(e.target.value);
                    setSelectedUnit({ unitId: "", unitName: "" });
                  }}
                />
              </Col>
            </Row>

            <Button color="primary" style={{ marginTop: "20px" }}>
              Add Unit
            </Button>
          </form>

          {/* ✅ Table */}
          <div style={{ marginTop: "30px" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Unit ID</th>
                  <th>Unit Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {units.map((u, i) => (
                  <tr key={i}>
                    <td>{u.unitId}</td>
                    <td>{u.unitName}</td>
                    <td>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(u.parentId, u._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}